import * as Compat from "src/Compat";
import * as Dati from "src/Dati";
import * as Glob from "src/Globale";
import { Trad } from "src/components/";
import { UsersImgSrc } from "../constants";

export const ManageRedirect = (url: string) => {
    if (Compat.ES6_String_endsWith(url, "/api/Utenti/SessioneScaduta")) {
        location.replace("/ErroreAccesso");
    } else {
        location.replace(url);
    }
};

export const DeleteEmptyParams = (paramsList: Dati.TListaParametri): Dati.TListaParametri => {
    for (var P in paramsList) {
        if (!paramsList[P] || paramsList[P] == "0") {
            delete paramsList[P];
        }
    }
    return paramsList;
};

export const GetUserImg = (val: string) => val && (Compat.ES6_String_startWith(val, "http") ? val : `${UsersImgSrc}/${val}`);

export const GetFormattedValue = (val: any, type: string): string => {
    switch (type) {
        case "Importo":
            return Glob.FormatNumber(val);
        case "Percentuale":
            return `${Glob.FormatNumber(val)}%`;
        case "Data":
            return Trad.Trad(val);
        default:
            return val;
    }
};



// WEBPACK FOOTER //
// ./src/inar2/helpers/Common.ts